import { createFileRoute, Link } from '@tanstack/react-router'
import { Clock, Mail, Rocket } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const Route = createFileRoute('/coming-soon')({
  component: ComingSoonPage,
})

function ComingSoonPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/30 flex items-center justify-center p-4 md:p-8">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-2xl">
        <Card className="border-none shadow-2xl bg-card/80 backdrop-blur-sm">
          <CardHeader className="text-center pb-2">
            <div className="mx-auto mb-6 p-4 rounded-full bg-primary/10">
              <Rocket className="w-12 h-12 text-primary" />
            </div>
            <CardTitle className="text-3xl md:text-4xl font-bold tracking-tight">
              Coming Soon
            </CardTitle>
            <CardDescription className="text-lg mt-2">
              We're working on something exciting!
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center space-y-6 pt-4">
            <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
              Our team is putting the finishing touches on something amazing. We're working hard to
              bring you an experience that will exceed your expectations.
            </p>

            <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
              <Clock className="w-4 h-4" />
              <span>Expected launch: Soon</span>
            </div>

            <div className="pt-4 border-t">
              <p className="text-sm text-muted-foreground mb-4">
                Want to be the first to know when we launch?
              </p>
              <div className="flex flex-col gap-3 max sm:flex-row-w-md mx-auto">
                <div className="relative flex-1">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="w-full h-10 pl-10 pr-4 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                </div>
                <Button className="h-10 px-6">Notify Me</Button>
              </div>
            </div>

            <div className="pt-6">
              <Button variant="outline" asChild>
                <Link to="/">Return to Home</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
